import { get, put } from "services/api";
import { isHost } from "utils/env";

type ThirdPartyApp = {
  id: number;
  name: string;
  clientId: string;
  webSite: string | null;
};
type MemberApi = {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dob?: string;
  isThirdPartyEnabled: boolean;
};

export const getThirdPartyApps = async (): Promise<{
  thirdPartyApps: ThirdPartyApp[];
  members: MemberApi[];
}> => {
  const res = await get({
    url: "/api/v1/third-party-apps",
    options: { baseUrl: isHost },
  });
  if (!res.ok) throw new Error("Failed to fetch third party apps");
  return res.json();
};

export const setThirdPartyAccess = async (
  subscriberId: string,
  turnOn: boolean,
  disableSubscriberId?: string,
) => {
  const res = await put({
    url: "/api/v1/third-party-apps",
    data: {
      subscriberId,
      turnOnThirdPartyAccess: turnOn,
      ...(disableSubscriberId ? { disableSubscriberId } : {}),
    },
    options: { baseUrl: isHost },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Failed to set access: ${res.status} ${text}`);
  }
  return res;
};

export default {
  getThirdPartyApps,
  setThirdPartyAccess,
};
